import { render, staticRenderFns } from "./BasePostulante.vue?vue&type=template&id=65c30cad&scoped=true&"
import script from "./BasePostulante.vue?vue&type=script&lang=js&"
export * from "./BasePostulante.vue?vue&type=script&lang=js&"
import style0 from "./BasePostulante.vue?vue&type=style&index=0&id=65c30cad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c30cad",
  null
  
)

export default component.exports